import { useQuery } from '@tanstack/react-query';

import { useHttpClient } from '@bonusly/http-client';

import { Label } from '../../../components/labels/lib/entities';
import { useBookmark } from '../../../context';
import { ResourcePath } from '../../../hooks/resource-path';
import { QueryKey } from '../../../lib/query-key';

interface LabelResponse {
	id: string;
	company_id: string;
	created_at: string;
	name: string;
	updated_at: string;
	user_id: string;
	bookmarks_count?: number;
}
export const useGetLabels = () => {
	const http = useHttpClient('v2');
	const { bookmark } = useBookmark();
	return useQuery([QueryKey.Labels], async () => http.get<Array<LabelResponse>>(ResourcePath.Labels), {
		staleTime: Infinity,
		refetchOnWindowFocus: false,
		select: (data) =>
			data.data.map((label) => {
				if (bookmark?.labels?.find((bookmarkLabel) => bookmarkLabel.id === label.id)) {
					return new Label({ ...label, isSelected: true });
				}
				return new Label(label);
			}),
	});
};
